export default __webpack_public_path__ + "static/media/sho1.0555688e.png";